import { FaBars, FaTimes } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../../redux/actions/auth.actions";
import { menuItems } from "../../sideNavbar/menuItem";
import './header.scss'


const Header = ({ toggleSidebar, showSidebar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const { isAuthenticated, loading, user } = useSelector((state) => state.authReducer);

  // Store user ID if available
  if (user !== null) {
    localStorage.setItem("userID", user.id);
  }

  const handleLogout = () => {
    dispatch(logout());
    navigate("/login");
  };

  return (
    <header
      className={`text-white px-3 px-md-4 py-3 d-flex justify-content-between align-items-center  ${showSidebar ? "w-100" : "m-3 shadow rounded-3"
        }`}
      style={{
        background: "rgba(0, 165, 162, 0.9)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1050,
      }}
    >
      <button onClick={toggleSidebar} className="btn btn-info"   style={{ borderColor: "white", color: "white" }}>
        {showSidebar ? <FaTimes size={20} /> : <FaBars size={20} />}
      </button>
      <div className="d-flex ">
        {!showSidebar &&
          menuItems.map((item, index) => {
            const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + "/");

            return (
              <div
                key={index}
                onClick={() => navigate(item.path)}
                className={`d-flex align-items-center gap-2 sidebar-icon ${
                  isActive ? "active " : ""
                }`}
                style={{
                  marginLeft: "1rem",
                }}
              >
                {item.icon}
                <span style={{ fontSize: "10px" }}>{item?.linkText}</span>
              </div>
            );
          })}

      </div>
      <div className="d-flex align-items-center gap-3">
        {!loading && isAuthenticated ? (
          <div className="d-flex align-items-center gap-3">
            <span className="fw-bold" style={{ fontSize: "0.9rem" }}>
              Hi 👋 , {user && user.name ? user.name : "User"}
            </span>

            <button
              onClick={handleLogout}
              className="btn btn-info"
              style={{ borderColor: "white", color: "white" }}
              title="Logout"
            >
              Logout
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
    </header>
  );
};

export default Header;
